// extracted by mini-css-extract-plugin
module.exports = {"iconsColorToggle":"EditableVideo_iconsColorToggle__5hRI1"};